import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import StarDivider from "@/components/StarDivider";
import { ExternalLink } from "lucide-react";
import { NEWS } from "@/data/content";

export default function News() {
  return (
    <>
      <SEO
        title="News & Updates | Veterans for Indiana"
        description="Follow the latest news from Veterans for Indiana — endorsement announcements, candidate updates, statements, and organizational news."
        path="/news"
      />

      <section className="bg-cream py-16">
        <div className="container-x text-center max-w-3xl mx-auto">
          <Reveal>
            <h1 className="h-display text-5xl sm:text-6xl text-navy">News &amp; Updates</h1>
            <div className="mt-4 flex justify-center"><StarDivider /></div>
            <p className="mt-6 text-navy-deep/80 leading-relaxed">
              Follow the latest from Veterans for Indiana — endorsement announcements, events, candidate updates, and organizational news.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {NEWS.map((n, i) => (
            <Reveal key={n.title} delay={((i % 3) + 1)}>
              <article className="card-lift h-full bg-white rounded-lg overflow-hidden shadow-sm ring-1 ring-gray-200 flex flex-col">
                <div className="aspect-[16/9] bg-navy-deep relative overflow-hidden">
                  <div className="absolute inset-0 pattern-stars opacity-80" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="font-display tracking-[0.22em] text-xs uppercase text-green-brand">Statement</span>
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <time className="font-display tracking-widest text-xs uppercase text-green-brand">{n.date}</time>
                  <h2 className="font-display text-xl text-navy uppercase mt-2 leading-tight">{n.title}</h2>
                  <span className="mt-3 inline-block h-[2px] w-10 bg-green-brand" />
                  <p className="mt-4 text-sm text-navy-deep/80 leading-relaxed flex-1">{n.excerpt}</p>
                  <a
                    href={n.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 font-display tracking-widest text-xs uppercase text-green-brand hover:text-navy inline-flex items-center gap-1"
                    data-testid={`news-read-more-${i}`}
                  >
                    Read More <ExternalLink size={14} />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
